import React from "react";

import AddEditVerifyIdentity from "./AddEditVerifyIdentity";
import AddEditBillingRates from "./AddEditBillingRates";
import AddEditPersonal from "./AddEditPersonal";
import AddEditTaxInformation from "./AddEditTaxInformation";
import AddEditInsurance from "./AddEditInsurance";
import useAuth from "../../../hooks/useAuth";
import { UserType } from "../../../utils/enum";
import { isIdentityLocked } from "../../../utils/helpers";
import ProfileSetting from "../ProfileSetting";
import CompanyInformation from "../../ProfileDetails/components/CompanyInformation";

const PersonalInformation = ({
  user,
  refetchMe,
  qualificationTypeMap,
  withProfileSections = false,
}) => {
  const { authRole } = useAuth();
  const role = user?.role?.role;
  const isCompanyOwner = !!user?.isCompanyOwner;
  const isCompanyMember = !!user?.isCompanyMember;

  const personal = (
    <AddEditPersonal
      firstName={user?.firstName}
      lastName={user?.lastName}
      email={user?.email}
      phoneNumber={user?.phoneNumber}
      authRole={authRole}
      userId={user?.id}
      profilePicture={user?.picture}
      refetchMe={refetchMe}
      createdAt={user?.createdAt}
      lastActive={user?.lastActive}
    />
  );

  if (role === UserType.CUSTOMER || role === UserType.CLIENT) {
    return (
      <>
        {personal}
        {withProfileSections && <ProfileSetting user={user} refetchMe={refetchMe} />}
      </>
    );
  }

  return (
    <>
      {personal}
      {/* An engineer's vendor is read here rather than on their profile, for whoever is
          reviewing them. The engineer knows their own company, so not on their own page. */}
      {authRole === UserType.ADMIN && isCompanyMember && user?.company && (
        <CompanyInformation company={user.company} />
      )}
      {/* A company owner is verified through the company, in Company Settings. */}
      {!isCompanyOwner && (
        <AddEditVerifyIdentity
          identityDocuments={user?.identityDocuments}
          refetchMe={refetchMe}
          personalAddress={user?.personalAddress}
          nationality={user?.nationality}
          userId={user?.id}
          authRole={authRole}
          identityLocked={isIdentityLocked(user)}
        />
      )}
      {!isCompanyOwner && (
        <AddEditTaxInformation
          australianBusinessNumber={user?.australianBusinessNumber}
          gstPercentage={user?.gstPercentage}
          foreignContractor={user?.isForeignContractor}
          refetchMe={refetchMe}
          authRole={authRole}
        />
      )}
      {!isCompanyOwner && !isCompanyMember && (
        <AddEditBillingRates
          billingRates={user?.billingRates}
          authRole={authRole}
          userData={user}
          refetchMe={refetchMe}
        />
      )}
      {!isCompanyOwner && (
        <AddEditInsurance
          insuranceId={qualificationTypeMap["insurance"]}
          authRole={authRole}
          userId={user?.id}
        />
      )}
      {/* A company owner's About Me describes the company, so it is in Company Settings. */}
      {withProfileSections && !isCompanyOwner && (
        <ProfileSetting
          user={user}
          refetchMe={refetchMe}
          qualificationTypeMap={qualificationTypeMap}
          withEngineerProfile
        />
      )}
    </>
  );
};

export default PersonalInformation;
